import "./styles.less";

import React, { FC, useContext, useState } from "react";
import { Col, Row, Skeleton, Space, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { IconFacility } from "./IconFacility/web";
import { useTheme } from "../../../Styles/ThemeHook";
import { FacilitiesProps, useFacilities } from "./Facilities.hook";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions";
import { OpenEyeIcon } from "shared-components/Components/CustomIcons/OpenEyeIcon/web";
import { CloseEyeIcon } from "shared-components/Components/CustomIcons/CloseEyeIcon/web";

export const Facilities: FC<FacilitiesProps> = ({
	mode = "auto",
	facilities = [],
	loading = false,
	isEspecial,
}) => {
	const { facilitiesList } = useFacilities(facilities);
	const { theme } = useTheme();
	const { country_code, translations } = useContext(ConfigStateContext);
	const [showAll, setShowAll] = useState(false);

	if (!facilitiesList || facilitiesList.length == 0) {
		return null;
	}

	const midIndex = Math.ceil(facilitiesList.length / 2);
	const firstColumn = facilitiesList.slice(0, midIndex);
	const secondColumn = facilitiesList.slice(midIndex);
	const titleText = mode === "project" ? firstLetterToUppercase(translations.amenities) : "Comodidades de la propiedad";

	const renderFacilities = (list) => {
		return list.map((o, i) => (
			<Row key={"property_facility_" + i}>
				<Space size={5} className={`${country_code}-facility-batch`}>
					{country_code !== "ce3" && (
						<Typography.Text type={"secondary"} className="small">
							{isEspecial ? (
								<CheckOutlined style={{ color: "#0ec6d5", marginRight: 8 }} />
							) : (
								"•"
							)}
						</Typography.Text>
					)}
					{country_code === "ce3" && <IconFacility id={o.id} />}
					<Typography.Text>{o.name}</Typography.Text>
				</Space>
			</Row>
		));
	};

	return (
		<Row gutter={[0, theme.spacing.lgSpacing]} className="property-facilities">
			<Col span={24} key="property_facilities">
				<h4 className="subhead subhead-semibold high">{titleText}</h4>
				{loading ? (
					<Skeleton active />
				) : (
					<>
						<Row gutter={[theme.spacing.xsSpacing, theme.spacing.xsSpacing]}>
							<Col span={8}>
								{renderFacilities(showAll ? firstColumn : firstColumn.slice(0, 6))}
							</Col>
							<Col span={11}>
								{renderFacilities(showAll ? secondColumn : secondColumn.slice(0, 6))}
							</Col>
						</Row>
						{(firstColumn.length > 6 || secondColumn.length > 6) && (
							<>
								{showAll ? (
									<a className="toggle-visibility" onClick={() => setShowAll(!showAll)}>
										<OpenEyeIcon width={16} />
										<span>Ver menos</span>
									</a>
								) : (
									<a className="toggle-visibility" onClick={() => setShowAll(!showAll)}>
										<CloseEyeIcon width={16} />
										<span>Ver más</span>
									</a>
								)}
							</>
						)}
					</>
				)}
			</Col>
		</Row>
	);
};
